// Phase 4-D6 GREEN — yW9sl 邀请奖励规则 modal
//
// frame_id=yW9sl @ ui/dogdisk-user.pen modals.md §yW9sl
// 触发:`UlwH9 RewardSection ?` icon → 弹 BottomSheet
// 实现决策:纯前端静态 i18n(per spec §7 默认决策;0 backend)
//
// 关键文案 / 规则源:.pen modals.md §yW9sl mock_in_pen 段:
//   rule1 "邀请注册,+1天VIP,最高30天"
//   rule2 "好友购买VIP,+7天VIP,最高90天"
//   rule3 "续费/升级 重复触发,无上限叠加"
//
// 后端可后续替换为 GET /v_invite_reward_rules 动态 enum
// (api-list/user/invite.md `❌ MISSING (Phase 4)` backlog 标记)。

export type InviteRulesModalProps = {
  open: boolean
  onClose: () => void
}

const RULES: { key: string; label: string; value: string; tone: 'primary' | 'muted' }[] = [
  { key: 'register', label: '邀请注册奖励', value: '+1天VIP', tone: 'primary' },
  { key: 'vip_purchase', label: '好友购买 VIP 奖励', value: '+7天VIP', tone: 'primary' },
  { key: 'no_cap', label: '续费 / 升级 重复触发', value: '无上限叠加', tone: 'muted' },
]

export function InviteRulesModal({ open, onClose }: InviteRulesModalProps) {
  if (!open) return null

  return (
    <div
      data-testid="yW9sl"
      role="dialog"
      aria-modal="true"
      aria-label="邀请奖励规则"
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl bg-white"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center pt-2 pb-3">
          <span className="h-1 w-10 rounded-full bg-[#E0E0E0]" />
        </div>

        <header className="px-6 py-3 text-center">
          <h2 className="text-[15px] font-semibold text-[#1A1A1A]">邀请奖励规则</h2>
          <p className="mt-0.5 text-[11px] text-[#9CA3AF]">分享文件也能赚取 VIP 天数</p>
        </header>

        <ul
          className="mx-6 mb-3 flex flex-col gap-2 rounded-2xl bg-[#F6F7F8] p-4 text-[13px]"
          data-testid="yW9sl-rules-list"
        >
          {RULES.map((r) => (
            <li key={r.key} data-testid={`yW9sl-rule-${r.key}`} className="flex justify-between">
              <span className="text-[#1A1A1A]">{r.label}</span>
              <span
                className={
                  r.tone === 'primary'
                    ? 'font-semibold text-[#19caad]'
                    : 'text-[#9CA3AF]'
                }
              >
                {r.value}
              </span>
            </li>
          ))}
        </ul>

        <p className="px-6 pb-3 text-[11px] text-[#9CA3AF]">
          ⚠ 仅对真实邀请有效。刷量 / 自邀作弊视为违规,可能取消奖励并冻结账号。
        </p>

        <div className="flex gap-2 px-6 pb-3">
          <button
            type="button"
            data-testid="yW9sl-close"
            onClick={onClose}
            className="h-11 flex-1 rounded-lg bg-[#19caad] text-[14px] font-semibold text-white"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  )
}
